import { useEffect, useState } from 'react';
import { api, type DbHealth } from '../lib/api';
import { MyFineRequests } from './Fine';
import { MyInvoiceRequests } from './InvoiceRequest';

const LABEL: Record<string, string> = {
  grp: '소속',
  garage: '차고지',
  cust: '거래처',
  car: '차량',
  driver: '기사',
  car_alloc: '운행차량편성',
  dispt: '노선',
  salary_month: '기사정산 원장',
};

export default function Home() {
  const [data, setData] = useState<DbHealth | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .dbHealth()
      .then(setData)
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  return (
    <div className="space-y-6">
      {/* 과태료 기사 확인 요청(관리기사A · 영업담당자) — 없으면 아무것도 안 그린다 */}
      <MyFineRequests />
      {/* 세금계산서 발행 요청(영업 → 회계) — 누구나 올리고, 회계 처리 소식은 팝업으로 온다 */}
      <MyInvoiceRequests />
      <div className="page-head">
        <h1 className="font-bold">대시보드</h1>
        <p className="mt-1 text-sm text-ink-soft">데이터베이스 접속 상태와 이관된 자료의 규모입니다.</p>
      </div>

      {error && (
        <div className="card border-red-200 bg-red-50 p-4 text-sm text-red-700">
          <div className="font-semibold">데이터베이스에 연결하지 못했습니다.</div>
          <div className="mt-1">{error}</div>
        </div>
      )}

      {!data && !error && <div className="text-sm text-ink-soft">불러오는 중…</div>}

      {data && (
        <>
          <div className="card p-4 text-sm">
            <dl className="grid grid-cols-[8rem_1fr] gap-y-2">
              <dt className="text-ink-soft">인스턴스</dt>
              <dd className="font-mono text-xs">{data.instance}</dd>
              <dt className="text-ink-soft">데이터베이스</dt>
              <dd>{data.actual?.db}</dd>
              <dt className="text-ink-soft">접속 계정</dt>
              <dd>{data.actual?.usr}</dd>
              <dt className="text-ink-soft">서버 시각</dt>
              <dd>{data.actual?.now_kst} (KST)</dd>
            </dl>
          </div>

          <div className="card overflow-hidden">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="th">구분</th>
                  <th className="th text-right">건수</th>
                </tr>
              </thead>
              <tbody>
                {data.counts.map((c) => (
                  <tr key={c.table_name}>
                    <td className="td">{LABEL[c.table_name] ?? c.table_name}</td>
                    <td className="td num">{Number(c.n).toLocaleString('ko-KR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
